import { CONTACT_POINT_SYSTEM, REGEX_EXPS } from "utils/constants";
import {
  getPhonePrefixFromYupContext,
  isValidLocalPhoneNumber,
} from "utils/helpers/phone";
import { normalizeTextField, stripAllSpaces } from "utils/helpers/validations";
import * as yup from "yup";

const validation = (errors) => {
  const requiredString = yup
    .string()
    .typeError(errors.REQUIRED)
    .required(errors.REQUIRED);
  const requiredName = yup
    .string()
    .transform(normalizeTextField)
    .typeError(errors.REQUIRED)
    .matches(REGEX_EXPS.name, errors.INVALID_NAME)
    .required(errors.REQUIRED);
  return yup.object().shape({
    telecoms: yup.object().shape({
      [CONTACT_POINT_SYSTEM.EMAIL]: yup.object().shape({
        value: yup
          .string()
          .nullable()
          .email(errors.EMAIL)
          .required(errors.REQUIRED),
      }),
      [CONTACT_POINT_SYSTEM.PHONE]: yup.object().shape({
        // Optional field ("Facultatif") — only validate the format when a
        // value is provided.
        value: yup
          .string()
          .transform(stripAllSpaces)
          .nullable()
          .required(errors.REQUIRED)
          .test("isValid", errors.INVALID_PHONE, async function (value) {
            if (!value) return true;
            const prefix = getPhonePrefixFromYupContext(this);
            return isValidLocalPhoneNumber(
              String(value || "").replace(/\s+/g, ""),
              prefix,
            );
          }),
      }),
    }),
    user: yup.object().shape({
      firstname: requiredName,
      lastname: requiredName,
      gender: requiredString,
    }),
  });
};

export default validation;
